import { Component, ComponentFactoryResolver } from "@angular/core";
import { SmallCardComponent } from "@app/home/cards/small-card/small-card.component";
import { SvgHealthRecordComponent } from "@app/home/svg/svg-health-record/svg-health-record.component";
import { HomePageAnalyticsService } from "@app/home/home-page-analytics.service";

@Component({
  selector: "om-health-record-card",
  templateUrl: "./small-card/small-card.component.html",
  styleUrls: ["./default-styling.scss", "./small-card/small-card.component.scss"],
})
export class HealthRecordCardComponent extends SmallCardComponent {
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private homePageAnalyticsService: HomePageAnalyticsService
  ) {
    super();
  }

  ngOnInit() {
    this.card = {
      svg: this.componentFactoryResolver.resolveComponentFactory(SvgHealthRecordComponent),
      title: "Health Record",
      link: "/health-record",
    };

    this.homePageAnalyticsService.trackHealthRecordLink("om-health-record-card a");

    super.ngOnInit();
  }
}
